import directOfferAPI from 'api/directOffersAPI';

export const createStat = (application_company_id: number, webservice_id: number, event_type: string) => {
  return(dispatch: any) => {
    return directOfferAPI.createStat(application_company_id: number, webservice_id: number, event_type: string);
  }
}



// WEBPACK FOOTER //
// ./src/actions/directOffers/index.js